import { Row, Col, Container } from "react-bootstrap";
import { MockProjectsDashboard } from "../../../Public/Landingpages/Components/MockScreens";

const Projects = () => {
  return (
    <>
    <Container>
      <Row className="align-items-center" style={{ paddingTop: "4.5rem", paddingBottom: "4.5rem", position: "relative" }}>
        <Col className="yellowdotWelcome" />
        <Col className="greendotWelcome" />
        <Col md={6} sm={12} style={{ marginBottom: "1.5rem" }}>
          <MockProjectsDashboard />
        </Col>
        <Col md={1} />
        <Col md={5} sm={12}>
          <span className="blueSubheaderTop">Project Management</span>
          <div className="landingpageHeader" style={{ fontWeight: "500", lineHeight: "120%", marginTop: "0.5rem" }}>
            Easily manage your projects
          </div>
          <p className="landingpageDescriptions">
            Collect and organize all project-related data — tasks, comments,
            planned hours and bills. Share real-time progress with your clients
            through a customer-facing dashboard via a shareable link.
          </p>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default Projects;
